<template>
  <div id="GoTop" @click="GoTop()">
    <img src="../assets/img/goTop.png">
    <!--    <span class="glyphicon glyphicon-chevron-up"></span>-->
  </div>
</template>
<script>
import {scrollToTop} from "@/unitls/scrollUtils";

export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      scrollToTop();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}

#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue